import {EntityKey} from '../entity/entity';

export class UploadFile {

  constructor() {
    this.documentType = "NONE";
  }

  entityKey!: EntityKey;
  fileBytes!: Uint8Array;
  fileName!: string;
  mimeType!: string;
  documentName!: string;
  documentType: string;

}
